import { render, staticRenderFns } from "./regulatingReservoir.vue?vue&type=template&id=296f2a89&scoped=true"
import script from "./regulatingReservoir.vue?vue&type=script&lang=js"
export * from "./regulatingReservoir.vue?vue&type=script&lang=js"
import style0 from "./regulatingReservoir.vue?vue&type=style&index=0&id=296f2a89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296f2a89",
  null
  
)

export default component.exports